import React from 'react';
import { useTheme } from '@rtkwlf/fenrir-react';

export const withFenrirLightTheme = <P extends {}>(
  Component: React.FunctionComponent<P>,
): React.FunctionComponent<P> => {
  return (props: P) => {
    // hook into the theme provider
    const theme = useTheme();

    /**
     * Since we only support light mode for now we are
     * going to force the theme mode to light
     */
    React.useEffect(() => {
      theme?.setThemeMode('light');
    });

    return <Component {...props} />;
  };
};
